import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input} from '@angular/core';
import {OccupationalProfile} from '../shared/occupational-profile';

@Component({
	selector: 'navigation-info',
	templateUrl: './navigation-info.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false
})
export class NavigationInfoComponent implements AfterViewInit {

	@Input()
	public occupationalProfile!: OccupationalProfile;

	toShow: VisibleElement[] = [
		{fragment: 'aan-het-woord', title: 'Een werknemer aan het woord'},
		{fragment: 'digitaal-infopakket', title: 'Is het beroep van [title] iets voor mij?'},
		{fragment: 'belangrijkste-vaardigheden', title: 'Belangrijkste vaardigheden'},
		{fragment: 'aanvullende-vaardigheden', title: 'Aanvullende vaardigheden'},
		{fragment: 'persoonlijke-vaardigheden', title: 'Persoonlijke vaardigheden'},
		{fragment: 'occupational-profile-charts', title: '[title] in cijfers'},
		{fragment: 'opleidingen-voor', title: 'Opleidingen voor [title]'},
		{fragment: 'vacatures-voor', title: 'Vacatures voor [title]'}
	];

	public visibleElements: VisibleElement[] = [];

	constructor(private changeDetector: ChangeDetectorRef) {}

	ngAfterViewInit(): void {
		setTimeout(() => this.updateVisibleElements(), 400);
		setTimeout(() => this.updateVisibleElements(), 2000);
    }

	private updateVisibleElements(): void {
		this.visibleElements = this.toShow
			.filter(element => element.fragment === 'opleidingen-voor' ?
				this.getInnerTextVindEenopleiding() :
				document.getElementById(element.fragment))
			.filter(element => element.fragment === 'vacatures-voor' ? document.getElementById('vacatures') : true)
			.map(element => ({
				...element,
				title: this.occupationalProfile.title?.nl
					? element.title.replace('[title]', this.occupationalProfile.title.nl)
					: element.title
			}));
		this.changeDetector.detectChanges(); // look at https://angular.dev/api/core/ApplicationRef.isStable (runs outside angular zone)
	}

	private getInnerTextVindEenopleiding(): any {
		const element = document.getElementsByTagName('vindeenopleiding-widget-opleidingen-voor-beroep')[0] as any;
		return element ? element.innerText : undefined;
	}
}

interface VisibleElement {
	fragment: string;
	title: string;
}
